/* eslint-disable */
import inView from "in-view";

export default {
  init() {
    inView.offset(100);
    inView(".animated-visual").on("enter", (el) => {
      el.classList.remove("animated-visual--not-found");
    });

    inView(".animated-block").on("enter", (el) => {
      el.classList.remove("animated-block--not-found");
    });

  },
};
